module.exports = __webpack_public_path__ + "img/rejoindre.1fc99b06.jpg";